export default window;

//# sourceMappingURL=window.js.map